import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { updatePopupVisibleSelector } from '@store/dashboards/ui/selectors';
import * as createSelectors from '@store/dashboards/create/selectors';
import * as updateSelectors from '@store/dashboards/update/selectors';
import * as dashboardsUIActions from '@store/dashboards/ui/actions';
import * as dashboardCreateActions from '@store/dashboards/create/actions';
import * as dashboardUpdateActions from '@store/dashboards/update/actions';
import UpdateDashboardPopup from './UpdateDashboardPopup';


const selector = createSelector(
  updatePopupVisibleSelector,
  createSelectors.createLoaderSelector,
  createSelectors.errorCodeSelector,
  createSelectors.payloadSelector,
  updateSelectors.updateLoaderSelector,
  updateSelectors.errorCodeSelector,
  updateSelectors.payloadSelector,
  (
    visible,
    creatingFetching,
    createErrorCode,
    createPayload,
    updatingFetching,
    updateErrorCode,
    updatePayload,
  ) => ({
    visible,
    isFetching: (!!createPayload || !!updatePayload) && (creatingFetching || updatingFetching),
    hasError: createErrorCode !== 0 || updateErrorCode !== 0,
  }),
);

export default connect(selector, {
  toggleVisible: dashboardsUIActions.toggleUpdatePopupVisible,
  initCreating: dashboardCreateActions.initRequest,
  initUpdating: dashboardUpdateActions.initRequest,
  createDashboard: dashboardCreateActions.createDashboardByDashboardType,
  updateDashboard: dashboardUpdateActions.updateDashboardById,
})(UpdateDashboardPopup);
